"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NavService = (function () {
    function NavService() {
        this.pages = new Array();
    }
    NavService.prototype.addNavItem = function (page) {
        this.pages.push(page);
    };
    return NavService;
}());
exports.NavService = NavService;



/** WEBPACK FOOTER **
 ** ./src/app/common/nav/nav.service.ts
 **/